import { useState } from "react";
import HideColumnsMenuStyles from "./HideColumnsMenuStyles";
import { Menu, Typography, MenuItem, Checkbox, IconButton } from "@mui/material";

const HideColumnsMenu = ({
    icon,
    items,
    onClickItem,
    disabled,
}: {
    icon: React.ReactNode;
    items: {
        id: string | number;
        name: string;
        isHidden?: boolean;
    }[];
    onClickItem: (ev: React.MouseEvent<HTMLLIElement, MouseEvent>, itemId: string | number) => void;
    disabled?: boolean;
}) => {
    const classes = HideColumnsMenuStyles();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const visibleColumns = items.filter((col) => !col.isHidden);

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton disabled={disabled} size="small" onClick={handleOpenMenu} sx={{ p: 0 }}>
                {icon}
            </IconButton>

            <Menu
                className={classes.menuWrapper}
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <li className={classes.itemHeader}>
                    <Typography className={classes.itemHeaderTitle}>Manage Columns</Typography>
                    <Typography className={classes.itemHeaderSubtitle}>{visibleColumns.length} Selected</Typography>
                </li>
                {items.map((item) => {
                    return (
                        <MenuItem key={item.id} className={classes.menuItem} onClick={(ev) => onClickItem(ev, item.id)}>
                            <Checkbox size="small" checked={!item.isHidden} />
                            <Typography>{item.name}</Typography>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export default HideColumnsMenu;
